export default __webpack_public_path__ + "static/media/favicon.03927f47.ico";